import * as React from "react";

function SvgIcCopy(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M5.33366 2C4.96547 2 4.66699 2.29848 4.66699 2.66667C4.66699 3.03486 4.96547 3.33333 5.33366 3.33333H10.667C11.7716 3.33333 12.667 4.22876 12.667 5.33333V10.6667C12.667 11.0349 12.9655 11.3333 13.3337 11.3333C13.7018 11.3333 14.0003 11.0349 14.0003 10.6667V5.33333C14.0003 3.49238 12.5079 2 10.667 2H5.33366ZM4.00033 4C3.26395 4 2.66699 4.59695 2.66699 5.33333V12C2.66699 12.7364 3.26395 13.3333 4.00033 13.3333H10.667C11.4034 13.3333 12.0003 12.7364 12.0003 12V5.33333C12.0003 4.59695 11.4034 4 10.667 4H4.00033ZM4.00033 5.33333H10.667V12L4.00033 12V5.33333Z" fill="currentColor" />
    </svg>
  );
}

export default SvgIcCopy;

